<template>
    <be-loading :active="!lead || !check || !survey || !report">
        <be-card>
            <div slot="header">
                <div class="tools" style="width:50%"><be-progress :progress="progress" color="success">{{ progress }}%</be-progress></div>
                <span class="card-title">Fortschritt</span>
            </div>
            <br>
            <ul class="user-timeline user-timeline-compact">
                <li :class="lead.class" v-if="lead">
                    <div class="user-timeline-date" v-if="lead.date">{{ lead.date }}</div>
                    <div class="user-timeline-title">Digital.Lead</div>
                    <div class="user-timeline-description">{{ lead.description }}</div>
                </li>
                <li :class="check.class" v-if="check">
                    <div class="user-timeline-date" v-if="check.date">{{ check.date }}</div>
                    <div class="user-timeline-title">Digital.Check</div>
                    <div class="user-timeline-description">{{ check.description }}</div>
                </li>
                <li :class="survey.class" v-if="survey">
                    <div class="user-timeline-date" v-if="survey.date">{{ survey.date }}</div>
                    <div class="user-timeline-title">Digital.Assessment</div>
                    <div class="user-timeline-description">{{ survey.description }}</div>
                </li>
                <li :class="report.class" v-if="report">
                    <div class="user-timeline-date" v-if="report.date">{{ report.date }}</div>
                    <div class="user-timeline-title">Digital.Report</div>
                    <div class="user-timeline-description">{{ report.description }}</div>
                </li>
            </ul>
        </be-card>
    </be-loading>
</template>

<script>
    export default {
        props: {
            assessment: Object,
        },

        computed: {
            progress() {
                if (this.assessment.isReportCompleted) {
                    return 100;
                }

                if (this.assessment.isAssessmentCompleted) {
                    return this.assessment.isInvited ? 75 : 66;
                }

                if (this.assessment.isCheckCompleted) {
                    return this.assessment.isInvited ? 50 : 33;
                }

                return this.assessment.isInvited ? 25 : 0;
            },
        },

        asyncComputed: {
            async lead() {
                if (!this.assessment.isInvited) {
                    return {
                        class: 'text-muted',
                        description: 'Dieser Kunde wurde nicht eingeladen.',
                    };
                }

                const coach = await this.assessment.getInvitedBy();

                return {
                    class: 'latest',
                    date: this.assessment.longInvitedAt,
                    description: `Eingeladen von ${coach.firstname} ${coach.lastname}.`,
                };
            },

            async check() {
                if (!this.assessment.isCheckCompleted) {
                    return {
                        description: 'Digital.Check noch nicht durchgeführt.',
                    };
                }

                const coach = await this.assessment.getCheckCompletedBy();

                if (!coach) {
                    return {
                        class: 'latest',
                        date: this.assessment.longCheckCompletedAt,
                        description: 'Digital.Check vom Kunden durchgeführt.',
                    };
                }

                return {
                    class: 'latest',
                    date: this.assessment.longCheckCompletedAt,
                    description: `Digital.Check durchgeführt von ${coach.firstname} ${coach.lastname}.`,
                };
            },

            async survey() {
                if (!this.assessment.isAssessmentCompleted) {
                    return {
                        description: 'Digital.Assessment noch nicht durchgeführt.',
                    };
                }

                const coach = await this.assessment.getAssessmentCompletedBy();

                return {
                    class: 'latest',
                    date: this.assessment.longAssessmentCompletedAt,
                    description: `Digital.Assessment durchgeführt von ${coach.firstname} ${coach.lastname}.`,
                };
            },

            async report() {
                if (!this.assessment.isReportCompleted) {
                    return {
                        description: 'Digital.Report noch nicht durchgeführt.',
                    };
                }

                const coach = await this.assessment.getAssessmentCompletedBy();

                return {
                    class: 'latest',
                    date: this.assessment.longReportCompletedAt,
                    description: `Digital.Report erstellt von ${coach.firstname} ${coach.lastname}.`,
                };
            },
        },
    };
</script>
